var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1721_1589)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1721_1589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56268 13.2109V16.6894C6.56268 16.9324 6.71868 17.1477 6.94968 17.2242C7.00743 17.2429 7.06668 17.2519 7.12518 17.2519C7.30068 17.2519 7.47018 17.1694 7.57818 17.0224L9.61293 14.2534L6.56268 13.2109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7639 0.104316C17.5914 -0.0179335 17.3649 -0.0344335 17.1774 0.0638165L0.302436 8.87632C0.102936 8.98057 -0.0148141 9.19357 0.00168595 9.41782C0.0189359 9.64282 0.168186 9.83482 0.380436 9.90757L5.07169 11.5111L15.0624 2.96857L7.33144 12.2828L15.1937 14.9701C15.2522 14.9896 15.3137 15.0001 15.3752 15.0001C15.4772 15.0001 15.5784 14.9723 15.6677 14.9183C15.8102 14.8313 15.9069 14.6851 15.9317 14.5208L17.9942 0.645817C18.0249 0.435817 17.9364 0.227316 17.7639 0.104316Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1721_1589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1721_1589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.c1afc3e90de8287ebfef74f4a9632671.svg";
export { ForwardRef as ReactComponent };